<template>
	<div>
		<sf-card width="500px" height="400px" title="년도별 판매건수">
			<bar-chart :height="300" ref="grpBar" :chartData="datacollection2" :options="options2" />
		</sf-card>

		<sf-card width="500px" height="400px" title="차종별 판매건수">
			<doughnut-chart :height="300" ref="grpDoughnut" :chartData="datacollection3" :options="options3" />
		</sf-card>

		<sf-card width="800px" height="400px" title="line Chart Example">
			<line-chart :height="300" ref="grpLine" :chartData="datacollection1" :options="options1" />
		</sf-card>

		<sf-card width="1200px" height="400px" title="Combo Chart Example">
			<combo-chart :height="300" ref="grpCombo" :chartData="datacollection4" :options="options4" />
		</sf-card>
	</div>
</template>

<script>
import Chart from '@/qmsUtils/chartModule';
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/GraphInfo/store/helpers';
import chartClickEvent from '@/qmsUtils/chartModule/ChartEvents';
export default {
	components: {
		BarChart: Chart.BarChart,
		DoughnutChart: Chart.DoughnutChart,
		LineChart: Chart.LineChart,
		ComboChart: Chart.ComboChart
	},
	data() {
		return {
			options1: {
				//Linechart
				responsive: true,
				maintainAspectRatio: false, // chart 높이 지정을 위해 필요
				plugins: {
					datalabels: {
						color: '#000', //데이터 값 표시 폰트 색상
						anchor: 'end'
					}
				},
				legend: {
					display: true,
					position: 'bottom' //범례 위치: 아래
				},
				scales: {
					yAxes: [
						{
							ticks: {
								beginAtZero: false,
								max: 100
							}
						}
					],
					xAxes: [
						{
							offset: true, //x축 앞에 공간 두는 설정
							gridLines: {
								display: false //x축 관련 실선 안보이게 처리
							}
						}
					]
				},
				onClick: (event, array) => {
					const chartSelf = this.$refs.grpLine.$data._chart;
					const vueSelf = this;
					chartClickEvent(event, array, chartSelf, vueSelf);
				}
			},
			options2: {
				//chart
				responsive: true,
				maintainAspectRatio: false, // chart 높이 지정을 위해 필요
				plugins: {
					datalabels: {
						color: '#000', //데이터 값 표시 폰트 색상
						anchor: 'end'
					}
				},
				legend: {
					display: true,
					position: 'bottom' //범례 위치: 아래
				},
				scales: {
					xAxes: [
						{
							stacked: true
						}
					],
					yAxes: [
						{
							stacked: true
						}
					]
				},
				onClick: (event, array) => {
					const chartSelf = this.$refs.grpBar.$data._chart;
					const vueSelf = this;
					chartClickEvent(event, array, chartSelf, vueSelf);
				}
			},
			options3: {
				responsive: true,
				maintainAspectRatio: false, // chart 높이 지정을 위해 필요
				plugins: {
					datalabels: {
						color: '#000', //데이터 값 표시 폰트 색상
						boxWidth: 8,
						padding: 10,
						usePointStyle: true,
						pointStyle: 'circle'
					}
				},
				legend: {
					display: true,
					position: 'bottom'
				},
				onClick: (event, array) => {
					const chartSelf = this.$refs.grpDoughnut.$data._chart;
					const vueSelf = this;
					chartClickEvent(event, array, chartSelf, vueSelf);
				}
			},
			options4: {
				responsive: true,
				maintainAspectRatio: false, // chart 높이 지정을 위해 필요
				plugins: {
					datalabels: {
						color: '#000', //데이터 값 표시 폰트 색상
						anchor: 'end'
					}
				},
				legend: {
					display: true,
					position: 'bottom' //범례 위치: 아래
				},
				scales: {
					yAxes: [
						{
							ticks: {
								beginAtZero: true
							}
						}
					]
				}
			}
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		datacollection1() {
			return {
				labels: this.LineChartLabel_, //x축 데이터( 년월)
				datasets: this.lineDataSet_
			};
		},
		datacollection2() {
			return {
				labels: this.stackedLabel_,
				datasets: this.stackedDataSet_
			};
		},
		datacollection3() {
			return {
				//labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
				labels: this.doughnutLabel_,
				datasets: this.doughnutDataSet_
			};
		},
		datacollection4() {
			return {
				labels: this.LineChartLabel_,
				datasets: this.MixedDataSet_

				//왼쪽바가 판매건수
				//오른쪽이 확정건수
				//라인이 불량율
				/*
				datasets: [
					{
						type: 'bar',
						label: '판매건수',
						data: [100, 150, 200, 220, 300, 310],
						backgroundColor: [
							'rgba(255, 99, 132, 0.2)',
							'rgba(54, 162, 235, 0.2)',
							'rgba(255, 206, 86, 0.2)',
							'rgba(75, 192, 192, 0.2)',
							'rgba(153, 102, 255, 0.2)',
							'rgba(255, 159, 64, 0.2)'
						],
						borderColor: [
							'rgba(255,99,132,1)',
							'rgba(54, 162, 235, 1)',
							'rgba(255, 206, 86, 1)',
							'rgba(75, 192, 192, 1)',
							'rgba(153, 102, 255, 1)',
							'rgba(255, 159, 64, 1)'
						],
						borderWidth: 1
					},
					{
						type: 'bar',
						label: '확정건수',
						data: [50, 100, 150, 170, 100, 410],
						backgroundColor: [
							'rgba(255, 99, 132, 0.2)',
							'rgba(54, 162, 235, 0.2)',
							'rgba(255, 206, 86, 0.2)',
							'rgba(75, 192, 192, 0.2)',
							'rgba(153, 102, 255, 0.2)',
							'rgba(255, 159, 64, 0.2)'
						],
						borderColor: [
							'rgba(255,99,132,1)',
							'rgba(54, 162, 235, 1)',
							'rgba(255, 206, 86, 1)',
							'rgba(75, 192, 192, 1)',
							'rgba(153, 102, 255, 1)',
							'rgba(255, 159, 64, 1)'
						],
						borderWidth: 1
					},

					{
						type: 'line',
						label: '불량율',
						data: [10, 7, 8, 11, 17, 7],
						borderColor: 'rgba(255,99,132,1)', // 선 색상
						backgroundColor: '#00ff0000'
					}
				]
				*/
			};
		}
	}, //end cu
	methods: {
		...serviceMethods,
		searchGraphList(carCd) {
			this.$sf_toggleLoading(true);

			this.setSearchParam_({ key: 'selRowCarCd', value: carCd });

			this.getGraphList_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});

			//this.$emit('Refresh', currentPageVal, pageUnitVal);
		}
	}
};
</script>

<style></style>
